import {
  GiftCardAddonOnlineResponse,
  GiftCardWebViewResponse,
} from '@ancon/wildcat-types'

import api from '../../../api'
import createAppAsyncThunk from '../../../store/createAppAsyncThunk'
import serializeError from '../../../store/utils/serializeError'

export const fetchGiftCardWebView = createAppAsyncThunk<
  GiftCardWebViewResponse,
  { giftCardShareKey: string }
>('giftCards/fetchGiftCardWebView', async ({ giftCardShareKey }) => {
  try {
    const response = await api.card.giftCards.get.giftCardWebView({
      giftCardShareKey,
    })
    return response.data
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
    throw err
  }
})

export const fetchGiftCardAddon = createAppAsyncThunk<
  GiftCardAddonOnlineResponse,
  {
    outletSlug: string
    isServerSide?: boolean
  }
>(
  'giftCards/fetchGiftCardAddon',
  async ({ outletSlug, isServerSide }, { rejectWithValue }) => {
    const baseURL = isServerSide
      ? process.env.INTERNAL_INTEGRATION_API_URL
      : undefined

    try {
      // TODO: Parse the white-label tenants and outlets filters
      const response = await api.integration.giftCardAddon.get.giftCardAddon(
        {
          urlSlug: outletSlug,
        },
        undefined,
        { baseURL },
      )
      return response.data
    } catch (error) {
      return rejectWithValue(serializeError(error))
    }
  },
)
